(typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {}).SENTRY_RELEASE = {
  id: "db6e46b77e5d63c4e22ecf23f6c1a57c7a8e1870"
};